import React from 'react';

const RacesClubSection = () => {
    const palmares = [
        {
          season: "2024",
          totals: { first: 4, second: 7, third: 5 },
          races: [
            { text: "3º Senior femenina. CARRERA REYES MAGOS PEÑAFLOR, Peñaflor (Irene Sánchez).", location: "Peñaflor" },
            { text: "2º Veterana A. CARRERA REYES MAGOS PEÑAFLOR, Peñaflor (Inma López).", location: "Peñaflor" },
            { text: "2º Senior femenina y top 10 general. CARRERA NOCTURNA SAN ANTONIO ABAD, Trigueros (Irene Sánchez).", location: "Trigueros" },
            { text: "2º Veterana A. CARRERA NOCTURNA SAN ANTONIO ABAD, Trigueros (Inma López).", location: "Trigueros" },
            { text: "3º Senior femenina. MEDIA MARATON PUENTE GENIL, Puente Genil (Irene Sánchez).", location: "Puente Genil" },
            { text: "2º Senior femenina. CARRERA URBANA CHICLANA, Chiclana (Inma López).", location: "Chiclana" },
            { text: "2º General femenina. XII CARRERA POPULAR TAMARGUILLO, Sevilla (Inma López).", location: "Sevilla" },
            { text: "1º Senior femenina. XII CARRERA POPULAR TAMARGUILLO, Sevilla (Irene Sánchez).", location: "Sevilla" },
            { text: "1º Senior masculino. XII CARRERA POPULAR TAMARGUILLO, Sevilla (Rubén Arias).", location: "Sevilla" }
          ]
        },
        {
          season: "2023",
          totals: { first: 20, second: 26, third: 19 },
          races: [
            { text: "1° Senior femenina. XL CARRERA VILLALBA DEL ALCOR, Villalba del alcor (Irene Sánchez).", location: "Villalba del Alcor" },
            { text: "3° Master A femenina. XL CARRERA VILLALBA DEL ALCOR, Villalba del alcor (Inma López).", location: "Villalba del Alcor" },
            { text: "3º Senior femenina. XX CARRERA DE LA ALGABA, La Algaba (Irene Sánchez).", location: "La Algaba" },
            { text: "2º Senior femenina. XLII VUELTA PEDESTRE, Morón de la frontera (Irene Sánchez).", location: "Morón de la Frontera" },
            { text: "3º Master 30. XLII VUELTA PEDESTRE, Morón de la frontera (Inma López).", location: "Morón de la Frontera" }
          ]
        },
        {
          season: "2022",
          totals: { first: 5, second: 8, third: 5 },
          races: [
            { text: "3° General femenina. SAN SILVESTRE DE PARADAS, Paradas (Irene Sánchez).", location: "Paradas" },
            { text: "1° General. I CARRERA PAPA NOEL, Sevilla (Irene Sánchez).", location: "Sevilla" },
            { text: "2° Veterana A femenina. VIII CARRERA VILLA DE PILAS, Pilas (Irene Sánchez).", location: "Pilas" }
          ]
        }
      ];
    
      const totalMedals = palmares.reduce(
        (acc, season) => {
          acc.first += season.totals.first;
          acc.second += season.totals.second;
          acc.third += season.totals.third;
          return acc;
        },
        { first: 0, second: 0, third: 0 }
      );
    
      return (
        <section className="palmares-section py-5">
          <div className="container">
            <h2 className="text-center mb-4">Palmarés</h2>
    
            <div className="text-center mb-5">
              <h5 className="text-muted">Total</h5>
              <div className="d-flex justify-content-center gap-4">
                <span className="badge bg-dark">🥇 {totalMedals.first}</span>
                <span className="badge bg-secondary">🥈 {totalMedals.second}</span>
                <span className="badge bg-light text-dark border">🥉 {totalMedals.third}</span>
              </div>
            </div>
    
            {palmares.map((seasonData, idx) => (
              <div key={idx} className="mb-5">
                <h4 className="text-muted">Temporada {seasonData.season}</h4>
                <div className="d-flex gap-4 mb-3">
                  <span className="badge bg-dark">🥇 {seasonData.totals.first}</span>
                  <span className="badge bg-secondary">🥈 {seasonData.totals.second}</span>
                  <span className="badge bg-light text-dark border">🥉 {seasonData.totals.third}</span>
                </div>
                <ul className="list-group list-group-flush">
                  {seasonData.races.map((race, i) => (
                    <li key={i} className="list-group-item">
                      {race.text} <span className="badge bg-light text-dark ms-2">{race.location}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
    
            <div className="text-center mt-5">
              <h5 className="text-muted text-success mb-3">Síguenos en redes</h5>
              <div className="d-flex justify-content-center gap-3">
              <a href="https://www.facebook.com/profile.php?id=100088920129546" target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark">
                  Facebook
                </a>
                <a href="https://web.whatsapp.com/send?phone=+34621234462" target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
  );
};

export default RacesClubSection;